import React from 'react'
import { Route, useRouteMatch } from 'react-router-dom'
import { useApiFormPublishAsset, useApiListPublishAsset } from '../../../../../../api-new/state/content'
import { Menu, MenuDelete, MenuItem, MenuLink } from '../../../../../../shared/menu/menu'
import { IconList, IconPublishing, IconRecycle } from '../../../../../../shared/icon/icon'
import { BreadcrumbView } from '../../../../../../context/breadcrumb.context'
import { CardFullHeightScrollY } from '../../../../../../shared/card/card-full-height-scroll-y'
import { TableAgClient } from '../../../../../../shared/table-builder/table-ag-client'
import { ColumnDateTime, ColumnMenu, ColumnSize, ColumnText } from '../../../../../../shared/table-builder/table-columns'
import { PublishAssetVersionlist } from './publish-asset-version-list'
import { Delete } from '../../../../../../shared/page/page-delete'
import { PublishAssetListRecycle } from './publish-asset-list-recycle'

export const PublishAssetList = ({ nodeID }) => {
  const { url } = useRouteMatch()

  const apiListPublishAsset = useApiListPublishAsset()

  const handleReady = () => apiListPublishAsset.get(`${nodeID}/node`)
  const handleDestroyed = () => apiListPublishAsset.init()

  const HeaderMenu = () =>
    <Menu>
      <MenuLink Icon={IconRecycle} text="recycle" to={`${url}/${nodeID}/recycle`} show={true} />
    </Menu>

  return (
    <React.Fragment>
      {/* The node's files and their versions; named as its ⋮ menu item is
          (common/menu/node-actions.js). */}
      <BreadcrumbView Icon={IconPublishing} text="file versions">
        <CardFullHeightScrollY title="file versions" HeaderMenu={HeaderMenu}>
          <TableAgClient apiList={apiListPublishAsset} onReady={handleReady} onDestoryed={handleDestroyed} pollInterval={5000}>
            <ColumnDateTime field="createdAt" />
            <ColumnDateTime field="updatedAt" />
            <ColumnText field="name" />
            <ColumnSize field="contentLength" header="Size" />
            <ColumnText field="version" header="Active Version" />
            <ColumnText field="versionCount" header="Versions" />
            <ColumnText field="uploadedBy" />
            <ColumnText field="notes" />
            <ColumnMenu
              menu={row =>
                <Menu small>
                  <MenuItem Icon={IconList} text="versions" to={`${url}/${row.id}/version`} show />
                  <MenuDelete to={`${url}/${row.id}/delete`} show />
                </Menu>}
            />
          </TableAgClient>
        </CardFullHeightScrollY>
      </BreadcrumbView>

      <Route path={`${url}/:assetID/version`}>
        <PublishAssetVersionlist />
      </Route>

      <Route path={`${url}/:nodeID/recycle`}>
        <PublishAssetListRecycle />
      </Route>

      <Route path={`${url}/:deleteID/delete`}>
        <Delete useApiForm={useApiFormPublishAsset} titleParam="name" successPath={url} />
      </Route>
    </React.Fragment>
  )
}
